'use client'

import React, { useMemo } from 'react'

import { useField, useForm, Select } from '@payloadcms/ui'
import cities from '../../utilities/data/Algeria_Cities.json'

interface DynamicCitySelectProps {
  path: string
  fieldProps?: any
}

export const DynamicCitySelect: React.FC<DynamicCitySelectProps> = ({ path, fieldProps }) => {
  const { value: cityId, setValue } = useField<string>({ path })
  const form = useForm()

  const selectedWillaya = form.getData()?.wilaya

  // Memoize the options array to prevent unnecessary recalculations
  const cityOptions = useMemo(() => {
    const filtered = selectedWillaya ? cities.filter((c) => c.wilaya_id === selectedWillaya) : []

    return [
      { label: 'Select a city', value: '' }, // Placeholder option
      ...filtered.map((city) => ({
        label: `${city.name} - ${city.ar_name}`,
        value: city.id,
      })),
    ]
  }, [selectedWillaya]) // Dependency: recalculate only when willaya changes

  // Find the full option object corresponding to the current cityId
  const selectedOption = useMemo(() => {
    return cityOptions.find((option) => option.value === cityId) || null
  }, [cityId, cityOptions]) // Dependencies: recalculate when cityId or options change

  // Custom onChange handler to extract the value
  const handleChange = (selected: { label: string; value: string } | null) => {
    setValue(selected ? selected.value : null) // Update useField state with primitive ID
  }

  return (
    <div className="!flex-auto">
      <label className="field-label">Commune / City</label>
      <Select
        value={selectedOption} // Pass the full selected option object
        onChange={handleChange}
        options={cityOptions} // Use the memoized options
        disabled={!selectedWillaya}
        className="payload-select"
        {...fieldProps}
      />
    </div>
  )
}
